import React from 'react';
import { CircularProgress } from '@mui/material';
import { SxProps, Theme } from '@mui/system';

type Props = {
  element: React.ReactElement;
  size?: number | string;
  loading?: boolean;
  sx?: SxProps<Theme>;
};

const LoadingElement: React.FC<Props> = ({ element, loading, size, sx }) => {
  if (loading) {
    return <CircularProgress size={size} sx={sx} />;
  } else {
    return element;
  }
};

export default LoadingElement;
